var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14287 0C4.20002 0 3.42859 0.675 3.42859 1.5V22.5C3.42859 23.325 4.20002 24 5.14287 24H22.2857C23.2286 24 24 23.325 24 22.5V6L17.1429 0H5.14287Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 6H24L17.1428 0V4.5C17.1428 5.325 17.9143 6 18.8571 6Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.5L18.8572 6H24V10.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 19.5C20.5714 19.9125 20.1857 20.25 19.7143 20.25H0.857143C0.385714 20.25 0 19.9125 0 19.5V12C0 11.5875 0.385714 11.25 0.857143 11.25H19.7143C20.1857 11.25 20.5714 11.5875 20.5714 12V19.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73633 14.2103C3.73633 14.0123 3.91461 13.7963 4.20176 13.7963H5.7849C6.67633 13.7963 7.47861 14.3183 7.47861 15.3188C7.47861 16.2668 6.67633 16.7948 5.7849 16.7948H4.64061V17.5868C4.64061 17.8508 4.44861 18 4.20176 18C3.97547 18 3.73633 17.8508 3.73633 17.5868V14.2103ZM4.64061 14.5515V16.0455H5.7849C6.24433 16.0455 6.60776 15.6908 6.60776 15.3188C6.60776 14.8995 6.24433 14.5515 5.7849 14.5515H4.64061ZM8.8209 18C8.59461 18 8.34776 17.892 8.34776 17.6288V14.2223C8.34776 14.007 8.59461 13.8503 8.8209 13.8503H10.3903C13.5223 13.8503 13.4538 18 10.452 18H8.8209ZM9.2529 14.5823V17.2688H10.3903C12.2409 17.2688 12.3232 14.5823 10.3903 14.5823H9.2529ZM14.5646 14.6303V15.5835H16.3123C16.5592 15.5835 16.806 15.7995 16.806 16.0088C16.806 16.2068 16.5592 16.3688 16.3123 16.3688H14.5646V17.628C14.5646 17.838 14.394 17.9993 14.154 17.9993C13.8523 17.9993 13.668 17.838 13.668 17.628V14.2215C13.668 14.0063 13.8532 13.8495 14.154 13.8495H16.56C16.8618 13.8495 17.04 14.0063 17.04 14.2215C17.04 14.4135 16.8618 14.6295 16.56 14.6295H14.5646V14.6303Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 20.25H3.42859V21H19.7143C20.1857 21 20.5714 20.6625 20.5714 20.25V19.5C20.5714 19.9125 20.1857 20.25 19.7143 20.25Z",
    fill: "#CAD1D8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.380735cc2755b0c0f4e49f47601a76b4.svg";
export { ForwardRef as ReactComponent };